import React from 'react';

import { SVGPropsType } from 'src/types';

const Calculator = (props: SVGPropsType) => {
    const { stroke, fill, onClick, style, className } = props;
    return (
        <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <g clipPath="url(#clip0_4659_63202)">
                <path
                    d="M7.29541 12.9496C10.3761 12.9496 12.8735 10.4521 12.8735 7.37143C12.8735 4.29072 10.3761 1.7933 7.29541 1.7933C4.2147 1.7933 1.71729 4.29072 1.71729 7.37143C1.71729 10.4521 4.2147 12.9496 7.29541 12.9496Z"
                    stroke={stroke}
                    strokeWidth="0.95625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.67212 5.69799C5.80326 5.32519 6.06211 5.01082 6.40283 4.81058C6.74354 4.61034 7.14413 4.53715 7.53364 4.60396C7.92315 4.67077 8.27644 4.87328 8.53095 5.17561C8.78546 5.47795 8.92475 5.8606 8.92417 6.2558C8.92417 7.37143 7.25073 7.92924 7.25073 7.92924"
                    stroke={stroke}
                    strokeWidth="0.95625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.29541 10.1605H7.30124"
                    stroke={stroke}
                    strokeWidth="0.95625"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4659_63202">
                    <rect
                        width="13.3875"
                        height="13.3875"
                        fill={fill}
                        transform="translate(0.601562 0.677681)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default Calculator;
